import React, { FunctionComponent, useContext, useState } from "react";
import { ChallengeRegistrationContext, ChallengeRegistrationContextProps } from "/src/contexts/ChallengeRegistrationContext";
import makeStyles from "@mui/styles/makeStyles";
import { PaymentOptionsView } from "/src/ui/challengesRegistration/payment/PaymentOptionsView";
import { RegistrationFormProps } from "/src/ui/challengesRegistration/registrationForm/RegistrationFormProps";
import { RegistrationFormContent } from "/src/ui/challengesRegistration/registrationForm/RegistrationFormFields";
import { RegistrationStatusHeader } from "/src/ui/challengesRegistration/registrationForm/RegistrationStatusHeader";
import { RegistrationSubmitButton } from "/src/ui/challengesRegistration/registrationForm/RegistrationSubmitButton";
import { HelperDialog } from "/src/ui/authorization/HelperDialog";
import { UserRole } from "/src/domain/shared/User";
import { Typography } from "@mui/material";
import { useTranslation } from "react-i18next";
import { checkExcludedEmail } from "/src/domain/shared/checkExcludedEmail";

export const RegistrationForm: FunctionComponent<RegistrationFormProps> = ({
  challengeData,
  currentUser,
  extraFields,
}) => {
  const classes = useStyles();
  const { t } = useTranslation();
  const { email, additionalProfileData } = useContext(ChallengeRegistrationContext) as ChallengeRegistrationContextProps;
  const [isHelperDialog, setHelperDialog] = useState(false);

  const addPrediction = (e: any) => {
    if (!e.target.prediction) return;

    e.target.prediction.value =
      (e.target["prediction-hours"].value.length
        ? e.target["prediction-hours"].value
        : "00") +
      ":" +
      e.target["prediction-minutes"].value +
      ":" +
      e.target["prediction-seconds"].value;
  };

  const handleSubmit = (e: React.SyntheticEvent) => {
    if (checkExcludedEmail(email)) {
      e.preventDefault();
      setHelperDialog(true);
      return;
    }
    addPrediction(e);
  }

  if (
    currentUser.role !== UserRole.STUDENT &&
    currentUser.linkedId &&
    currentUser.linkedId > 0 &&
    Number(currentUser.id) != currentUser.linkedId
  ) {
    return (
      <Typography variant="h6" align="center" sx={{ margin: "1rem 0" }}>
        {t("loginToStudent")}
      </Typography>
    );
  }

  return (
    <form method="post" onSubmit={handleSubmit}>
      <RegistrationStatusHeader
        challengeData={challengeData}
        currentUser={currentUser}
      />
      <div className={classes.formContent}>
        <RegistrationFormContent
          challengeData={challengeData}
          currentUser={currentUser}
          extraFields={extraFields}
        />
        {Boolean(challengeData.isPaid) && (
          <PaymentOptionsView paymentInfo={challengeData.payment} />
        )}
        <RegistrationSubmitButton
          challengeData={challengeData}
          currentUser={currentUser}
          disabled={!!additionalProfileData.firstName.error 
            || !!additionalProfileData.lastName.error 
            || !!additionalProfileData.birthDate.error}
        />
      </div>
      <HelperDialog 
        isOpen={isHelperDialog} 
        onClose={() => setHelperDialog(!isHelperDialog)}
        title={ t('emailInvalid') }
        description={ t('invalidateMailDomains') }
      />
    </form>
  );
};

const useStyles = makeStyles({
  formContent: {
    padding: "0 1.5rem",
  },
});
